import appState from "./modules/appState";
import commonState from "./modules/utils/commonState";
import departmentState from "./modules/permission/departmentState";
import deviceState from "./modules/device/deviceState";
import frpServerState from "./modules/frpServer/frpServerState";
import liveStreamState from "./modules/liveStream/liveStreamState";
import menuState from "./modules/permission/menuState";
import moduleState from "./modules/permission/moduleState";
import roleState from "./modules/permission/roleState";
import scheduleState from "./modules/schedule/scheduleState";
import { store } from "rfx-core";
import userState from "./modules/permission/userState";
import deviceStatusState from "./modules/log/deviceStatusState";
import streamInfoState from "./modules/log/streamInfoState";
import terminalState from "./modules/terminal/terminalState";
import liveState from "./modules/live/liveState";
import flowState from "./modules/source/flowState";
import aggServerState from "./modules/aggServer/aggServerState";
import casterState from "./modules/caster/casterState";
import modelState from "./modules/model/modelState";
import upgradeState from "./modules/upgrade/upgradeState";
import profileState from "./modules/profile/profileState";
import channelDeptState from './modules/channelDept/channelDeptState';
import deviceManageState from './modules/deviceManage/deviceManageState';
import userManageState from "./modules/userManage/userManageState";
import pushManageState from "./modules/pushManage/pushManageState";
import healthState from "./modules/health/healthState";
import dataStatisticsState from "./modules/dataStatistics/dataStatisticsState";
import electricFenceState from "./modules/electricFence/electricFenceState";
import homeState from "./modules/home/homeState";
import workbenchState from "./modules/workbench/workbenchState";

export default store.setup({
    // 共用模块
    appState,
    commonState,
    // 个人信息
    profileState,
    // 权限管理
    moduleState,
    menuState,
    roleState,
    userState,
    departmentState,
    // mrs-c调度
    scheduleState,
    // 设备管理
    deviceState,
    // 直播流管理
    liveStreamState,
    // frp服务器管理
    frpServerState,
    //设备状态日志
    deviceStatusState,
    //流信息日志
    streamInfoState,
    // 终端管理
    terminalState,
    // 直播管理
    liveState,
    // 用户资源
    flowState,
    // 聚合服务器
    aggServerState,
    // 云导播
    casterState,
    // 终端model管理
    modelState,
    // 终端升级管理
    upgradeState,
		// 渠道管理
		channelDeptState,
		// 设备管理
		deviceManageState,
		// 用户管理
		userManageState,
		// 推送管理
		pushManageState,
    // 健康数据
    healthState,
    // 数据统计
    dataStatisticsState,
    // 电子围栏
    electricFenceState,
    // 首页数据大屏
    homeState,
    // 工作台
    workbenchState
});
